module.exports = __webpack_public_path__ + "static/media/amine.bbf9c948.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/equipe/amine.png
// module id = 2266
// module chunks = 0